export default "__VITE_ASSET__68e0af3f__"